import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { RowComponent } from './RowComponent';
import { DraggableRow, DragHandle, RowWrapper } from './styled';
import { HolderOutlined } from '@ant-design/icons';
import type { ColumnWidths } from './types';

interface SortableRowProps {
  flowMeta: {
    id: string | number;
    name: string;
    [key: string]: any;
  };
  columnWidths: ColumnWidths;
}

export const SortableRow = ({ flowMeta, columnWidths }: SortableRowProps) => {
  const flowId = typeof flowMeta.id === 'number' ? String(flowMeta.id) : flowMeta.id;

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: flowId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <DraggableRow ref={setNodeRef} style={style} {...attributes}>
      <DragHandle {...listeners}>
        <HolderOutlined />
      </DragHandle>
      <RowWrapper>
        <RowComponent flowMeta={flowMeta} columnWidths={columnWidths} />
      </RowWrapper>
    </DraggableRow>
  );
};
